import SlsTemplateImagemClient from '@/api/SistemaDKP/sls-template-imagem.client';
import SLSFamiliaComercialService from '@/services/sls-familia-comercial.service';
import SLSMarcaService from '@/services/SistemaDKP/sls-marca.service';
import store from '@/store';
import EsMarcaClient from '@/api/SistemaDKP/sls-marca.client';
import S3BucketService from '@/services/s3-bucket.service';
import Notifier from '@/libs/Notifier';
import { resolveImagemUrl, IMAGEM_PADRAO } from '@/utils/imagemUrl';

export default class SlsTemplateImagemService {
  constructor() {
    this.client = new SlsTemplateImagemClient();
    this.SLSMarcaService = new SLSMarcaService();
    this.slsFamiliaComercialService = new SLSFamiliaComercialService();
    this.s3BucketService = new S3BucketService();
    this.store = store;
    this.notify = new Notifier();
  }

  async findAll() {
    try {
      const {
        data,
        ...pagination
      } = await this.client.getTemplateImagem(this.store.getters['slsTemplateImagem/getFilters']);
      this.store.commit('slsTemplateImagem/setImagensHome', data);
      this.store.commit('slsTemplateImagem/setFilters', pagination);
    } catch (error) {
      console.log(error);
    }
  }

  async findById(id) {
    try {
      const data = await this.client.getTemplateImagemById(id);
      this.store.commit('slsTemplateImagem/setCurrentTemplateImagem', data);
    } catch (error) {
      console.log(error);
    }
  }

  async findAllMarcars() {
    try {
      const { data, ...pagination } = await this.clientMarca.getEsMarca({
        page: 1,
        perPage: 100,
        hasMore: true,
      });
      this.store.commit('slsTemplateImagem/setOptionsMarcas', data);
    } catch (error) {
      console.log(error);
    }
  }

  async create(templateImagem) {
    this.store.commit('slsTemplateImagem/setIsLoading', true);
    try {
      if (!templateImagem.imagens || templateImagem.imagens.length === 0) {
        throw new Error('ERROR_IMAGENS_NOT_FOUND');
      }

      const imagemPrincipal = templateImagem.imagens.find((img) => img.imagem_principal === 1);
      if (!imagemPrincipal) {
        throw new Error('ERROR_IMAGEM_PRINCIPAL_NOT_FOUND');
      }

      templateImagem.imagens = await Promise.all(templateImagem.imagens.map(async (imagem, index) => {
        console.log('IMAGENS: ', imagem);

        if (imagem.caminho_upload && typeof imagem.caminho_upload === 'string') {
          imagem.caminho = imagem.caminho_upload;
        }

        const isBase64 = imagem.caminho_base64 && (imagem.caminho_base64.startsWith('data:image') || imagem.caminho_base64.startsWith('/img/'));

        if (isBase64) {
          return imagem;
        }

        if (imagem.caminho_base64) {
          delete imagem.caminho_base64;
        }

        if (typeof imagem.caminho === 'string') {
          return imagem;
        }

        if (typeof imagem.caminho === 'object') {
          const urlImg = await this.s3BucketService.upload(
            imagem.caminho,
            'image',
            `imagens/${templateImagem.cod_marca}/`,
          ).then((res) => res.image_url);
          return {
            ...imagem,
            caminho: urlImg,
          };
        }

        return imagem;
      }));

      if (!Array.isArray(templateImagem.imagens) || templateImagem.imagens.length === 0) {
        throw new Error('ERRO: Imagens processadas inválidas.');
      }

      const { data } = await this.client.postTemplateImagem(templateImagem);
      if (this.store.state.slsTemplateImagem.copyCurrentTemplateImagem) {
        this.store.commit('slsTemplateImagem/addOfUpdateTemplateImagem', data);
      } else {
        console.error('Erro: copyCurrentTemplateImagem está null.');
      }
      this.notify.success(data.message);
    } catch (error) {
      console.error('errofront-end:', error);
      const errorMessages = {
        ERROR_IMAGENS_NOT_FOUND: 'É necessário adicionar pelo menos uma imagem',
        ERROR_IMAGEM_PRINCIPAL_NOT_FOUND: 'É necessário definir uma imagem principal',
      };

      const errorMessage = errorMessages[error.message] || error.message;
      throw this.notify.error(errorMessage);
    } finally {
      this.store.commit('slsTemplateImagem/setIsLoading', false);
    }
  }

  // async create(templateImagem) {
  //     this.store.commit('slsTemplateImagem/setIsLoading', true);
  //     try {
  //         templateImagem.imagens = await Promise.all(templateImagem.imagens.map(async (imagem, index) => {
  //             // Verifica se "caminho_base64" existe e é uma string antes de usar "startsWith"
  //             if (imagem.caminho_base64 && typeof imagem.caminho_base64 === 'string') {
  //                 let isBase64 = imagem.caminho_base64.startsWith('data:image') || imagem.caminho_base64.startsWith('/img/');
  //                 if (isBase64) {
  //                     return imagem;
  //                 }
  //             }

  //             // Remove "caminho_base64" se for inválido
  //             delete imagem.caminho_base64;

  //             // Verifica se "caminho" é uma string
  //             if (imagem.caminho && typeof imagem.caminho === 'string') {
  //                 return imagem;
  //             }

  //             // Se "caminho" for um objeto, realiza o upload
  //             if (imagem.caminho && typeof imagem.caminho === 'object') {
  //                 const urlImg = await this.s3BucketService.upload(imagem.caminho, 'image', `imagens/${templateImagem.cod_marca}/`).then(res => res.image_url);
  //                 return {
  //                     ...imagem,
  //                     caminho: urlImg,
  //                 };
  //             }

  //             // Retorna a imagem original caso nenhuma das condições seja atendida
  //             return imagem;
  //         }));
  //         const { data } = await this.client.postTemplateImagem(templateImagem);
  //         this.store.commit('slsTemplateImagem/addOfUpdateTemplateImagem', data);
  //         this.notify.success(data.message);
  //     } catch (error) {
  //         throw this.notify.error(error.message);
  //     } finally {
  //         this.store.commit('slsTemplateImagem/setIsLoading', false);
  //     }
  // }

  async updatedImagens(templateImagem) {
    this.store.commit('slsTemplateImagem/setIsLoading', true);

    if (!this.store.getters['slsTemplateImagem/getIsAlteracao']) {
      this.notify.info('Nenhuma alteração foi realizada');
      this.store.commit('slsTemplateImagem/setIsLoading', false);
      return;
    }

    try {
      const processedImagens = await Promise.all(templateImagem.imagens.map(async (imagem, index) => {
        // Se já for uma URL válida, retorna a imagem sem modificação
        if (typeof imagem.caminho === 'string' && this.isValidURL(imagem.caminho)) {
          return imagem;
        }

        // Se for uma string mas não é URL nem base64, provavelmente é caminho local
        if (typeof imagem.caminho === 'string' && !imagem.caminho.startsWith('data:image')) {
          return imagem;
        }

        let fileToUpload = null;

        try {
          // Tratamento de base64
          if (typeof imagem.caminho === 'string' && imagem.caminho.startsWith('data:image')) {
            fileToUpload = this.converBase64ParaFile(imagem.caminho, `imagem_${index}.png`);
          }
          // Tratamento de File/Blob
          else if (imagem.caminho instanceof File || imagem.caminho instanceof Blob) {
            fileToUpload = imagem.caminho;
          }

          // Se não conseguiu criar um arquivo para upload, usa imagem padrão
          if (!fileToUpload) {
            return {
              ...imagem,
              caminho: IMAGEM_PADRAO,
            };
          }

          // Tenta fazer o upload
          const uploadResult = await this.s3BucketService.upload(
            fileToUpload,
            'image',
            `imagens/${templateImagem.cod_marca}/`,
          );

          if (!uploadResult || !uploadResult.image_url) {
            throw new Error('URL da imagem não retornada pelo servidor');
          }

          return {
            ...imagem,
            caminho: uploadResult.image_url,
          };
        } catch (uploadError) {
          console.log(`Erro no upload da imagem ${index}:`, uploadError);
          // Em caso de erro no upload, retorna a imagem padrão
          return {
            ...imagem,
            caminho: IMAGEM_PADRAO,
          };
        }
      }));

      templateImagem.imagens = processedImagens;

      const { data } = await this.client.postTemplateImagemFamiliaComercialCodMarcaUpdatedImagens(templateImagem);
      this.store.commit('slsTemplateImagem/addOfUpdateTemplateImagem', data);
      this.notify.success(data.message);
    } catch (error) {
      console.error('Erro no processamento das imagens:', error);
      throw this.notify.error(error.message);
    } finally {
      this.store.commit('slsTemplateImagem/setIsLoading', false);
    }
  }

  async delete(id) {
    this.store.commit('slsTemplateImagem/setIsLoading', true);
    try {
      const { data } = await this.client.deleteTemplateImagemSoftDelete(id);
      this.store.commit('slsTemplateImagem/deleteTemplateImagem', id);
      this.notify.success(data.message);
    } catch (error) {
      throw this.notify.error(error.message);
    } finally {
      this.store.commit('slsTemplateImagem/setIsLoading', false);
    }
  }

  async loadRecursos() {
    this.store.commit('slsTemplateImagem/setIsLoading', true);
    try {
      await this.slsFamiliaComercialService.findAll();
      await this.SLSMarcaService.findAll();

      store.commit('slsTemplateImagem/setOptionsMarcas', store.getters['slsMarca/getEsMarcas']);
      store.commit('slsTemplateImagem/setOptionsReferencias', store.getters['slsFamiliaComercial/getFamiliasComerciais']);
    } catch (error) {
      throw this.notify.error(error.message);
    } finally {
      this.store.commit('slsTemplateImagem/setIsLoading', false);
    }
  }

  async loadFamiliaComercial(codMarca) {
    this.store.commit('slsTemplateImagem/setIsLoading', true);
    try {
      const { data } = await this.client.getTemplateImagemReferenciaByCodMarca(codMarca);
      this.store.commit('slsTemplateImagem/setOptionsReferencias', data);
    } catch (error) {
      throw this.notify.error(error.message);
    } finally {
      this.store.commit('slsTemplateImagem/setIsLoading', false);
    }
  }

  async loadConfigImagensByMarcaFamiliaComercial(codMarca, familiaComercialId) {
    this.store.commit('slsTemplateImagem/setIsLoading', true);
    try {
      if (!familiaComercialId || !codMarca) {
        throw new Error('Favor informar a marca e a família comercial');
      }
      const { data } = await this.client.getTemplateImagemConfigByMarcaFamiliaComercial(codMarca, familiaComercialId);
      const firstData = data[0];
      this.store.commit('slsTemplateImagem/setTemplateImagem', {
        ...firstData,
        imagens: data.map((i) => ({
          ...i,
          caminho: resolveImagemUrl(i.caminho),
        })),
      });
    } catch (error) {
      throw this.notify.error(error.message);
    } finally {
      this.store.commit('slsTemplateImagem/setIsLoading', false);
    }
  }

  async uploadLocalImagem(file, marcaNome, familiaDescricao, nomeArquivo) {
    if (!file) {
      throw new Error('Arquivo nao informado');
    }
    if (!marcaNome || !familiaDescricao) {
      throw new Error('Marca e referencia sao obrigatorias');
    }
    const formData = new FormData();
    formData.append('file', file);
    formData.append('marca_nome', marcaNome);
    formData.append('familia_descricao', familiaDescricao);
    if (nomeArquivo) {
      formData.append('nome_arquivo', nomeArquivo);
    }
    return this.client.uploadTemplateImagemLocal(formData);
  }

  isValidURL(string) {
    try {
      new URL(string);
      return true;
    } catch (_) {
      return false;
    }
  }

  blobToBase64(blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onerror = reject;
      reader.onload = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  }

  converBase64ParaFile(base64, fileName) {
    const [dataPrefix, data] = base64.split(',');

    const contentType = dataPrefix.split(':')[1].split(';')[0];

    const byteCharacters = atob(data);

    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const blob = new Blob([new Uint8Array(byteNumbers)], { type: contentType });

    return new File([blob], fileName, { type: contentType });
  }

  async fetchImageAsFile(imagePath) {
    if (!this.isValidURL(imagePath)) {
      throw new Error('O caminho da imagem não é um link válido.');
    }

    const response = await fetch(imagePath);
    if (!response.ok) {
      throw new Error(`Erro ao obter a imagem: ${response.statusText}`);
    }
    const blob = await response.blob();

    if (blob.size === 0) {
      throw new Error('O blob da imagem está vazio.');
    }

    const file = new File([blob], 'image.png', { type: 'image/png' });

    if (file.size === 0) {
      throw new Error('O arquivo da imagem está vazio.');
    }

    const base64 = await this.blobToBase64(blob);
    return { file, base64 };
  }
}
